import React, { useState, useEffect } from 'react';
import { DropDownComponent, InputComponent, TextAreaComponent, FileUploadComponent } from '../custcomponents';
import { useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { toast } from 'react-toastify';
import { AxiosAdminInstance } from '../utils';
import Modal from 'react-modal';
import { validate } from '../validatorutil';


// Main Event Component (Handles State)
const AddSpeaker = () => {

    const { eventcode } = useParams();
    const [speakerStatus, setSpeakerStatus] = useState('DRAFT');
    const [company, setCompany] = useState('' as any);
    const [designation, setDesignation] = useState('' as any);
    const [speakerPriority, setSpeakerPriority] = useState('' as any);
    const [speakerType, setSpeakerType] = useState('' as any);
    const [mailid, setMailid] = useState('' as any);
    const [imageupload, setImageupload] = useState(null as any);
    const [imageChanged, setImageChanged] = useState(false);
    const [speakername, setSpeakername] = useState('' as any);
    const [linkedInUrl, setLinkedInUrl] = useState('' as any);
    const [twitterUrl, setTwitterUrl] = useState('' as any);
    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [editInProgress, setEditInProgress] = useState(false);
    const [aboutSpeaker, setAboutSpeaker] = useState('' as any);
    const [aboutSpeakerShort, setAboutSpeakerShort] = useState('' as any);
    const [eventTicketTypesList, setEventTicketTypesList] = useState([] as any);
    const [speakersListresp, setSpeakersListresp] = useState([] as any);
    const [reloadList, setReloadList] = useState(false);
    const [currImage, setCurrImage] = useState('' as any);
    const [filterText, setFilterText] = useState('');
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    const [modalIsOpen, setIsOpen] = React.useState(false);



    function afterOpenModal() {
    }

    function closeModal() {
        setIsOpen(false);
    }
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            const { data: response } = await AxiosAdminInstance.get('/api/getspeakers?eventcode=' + eventcode);
            console.log(response);
            if (response.result != "Success" || response.data?.length == 0) {
                setSpeakersListresp([]);
                setLoading(false);
                return;
            }
            setSpeakersListresp(response.data);
            setLoading(false);
        }
        fetchData();
    }, [reloadList]);

    const listevtcolumns = [
        {
            name: 'Action',
            button: true,
            cell: row => (
                <>
                    <a href="#" onClick={(e) => { onSpeakerEdit(e, row) }}>
                        Edit
                </a>
                </>
            ),
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        }, {
            name: 'Company',
            selector: row => row.company,
            sortable: true,
        },
        {
            name: 'Designation',
            selector: row => row.designation,
            sortable: true,
        }, {
            name: 'Mail Id',
            selector: row => row.mailid,
            sortable: true,
        },
        {
            name: 'Status',
            selector: row => row.status,
            sortable: true,
        },
        {
            name: 'Priority',
            selector: row => row.priority,
            sortable: true,
        },
        {
            name: 'Speaker Type',
            selector: row => row.speakerType,
            sortable: true,
        },
        {
            name: 'Image',
            selector: row => (
                <>

                    <a href="#" onClick={(e) => { onShowImage(e, row.image) }}>
                        ShowImage
                </a>
                </>
            ),
            sortable: true,
        },

    ];
    const onShowImage = async (e: any, imageData: any) => {
        console.log(imageData);
        setCurrImage(imageData);
        setIsOpen(true);
    }
    const onSpeakerEdit = async (e: any, eventobj: any) => {
        e.preventDefault();
        console.log(eventobj);
        setSpeakerStatus(eventobj.status);
        setSpeakername(eventobj.name);
        setImageupload(eventobj.image);
        setDesignation(eventobj.designation);
        setMailid(eventobj.mailid);
        setAboutSpeaker(eventobj.aboutspeaker);
        setCompany(eventobj.company);
        setAboutSpeakerShort(eventobj.aboutspeakershort);
        setEditInProgress(false);
        setEditInProgress(true);
        setImageChanged(false);
        setSpeakerPriority(eventobj.priority);
        setSpeakerType(eventobj.speakerType);
        let socialmedia: any = eventobj.socialmedia;
        if (socialmedia) {
            socialmedia.forEach(element => {
                if (element.media == "linkedin") {
                    setLinkedInUrl(element.profileurl);
                } else if (element.media == "twitter") {
                    setTwitterUrl(element.profileurl);
                }
            });
        }
    }

    const onClickResetEvent = (e: any) => {
        if (e) {
            e.preventDefault();
        }
        setEventTicketTypesList([]);
        setDesignation('');
        setMailid('');
        setImageupload('');
        setLinkedInUrl('');
        setAboutSpeaker('');
        setSpeakerStatus('');
        setTwitterUrl('');
        setCompany('');
        setCurrImage('');
        setSpeakername('');
        setAboutSpeakerShort('');
        setSpeakerPriority('');
        setSpeakerType('Speaker Type');
        setImageChanged(false);
        setEditInProgress(false);
    }
    const onClickAddEvent = async (e: any) => {
        e.preventDefault();
        if (!validate('Speaker Name', speakername, 'name', false, 'txtspkrname') || !validate('Company', company, 'company', false, 'txtespkrcompany') ||
            !validate('Designation', designation, 'title', false, 'txtespkrdesignation') ||
            !validate('Mailid', mailid, 'email', false, "txtespkrmailid") ||
            !validate('About Speaker', aboutSpeaker, 'none', false, "txtspkrabout") ||
            !validate('About Speaker Short', aboutSpeakerShort, 'none', false, "txtspkraboutshort") ||
            !validate('Speaker Status', speakerStatus, 'speakerstatus', false, "txtSpkrstatus") ||
            !validate('Image', imageupload, 'none', false, "txtespkrimageurl") ||
            !validate('LinkedIn Url', linkedInUrl, 'linkedinurl', true, "txtspkrlinkedin") ||
            !validate('Twitter', twitterUrl, 'none', true, "txtespkrtwitterlink") ||
            !validate('Speaker Priority', speakerPriority, 'price', true, "txtespkrpriority")
        ) {

            return;
        }

        setSubmitLoading(true);

        let socialmedia: any = [

        ]

        if (linkedInUrl) {
            socialmedia.push({ media: "linkedin", profileurl: linkedInUrl });
        }
        if (twitterUrl) {
            socialmedia.push({ media: "twitter", profileurl: twitterUrl });
        }

        let evtObj: any = {
            name: speakername,
            eventcode: eventcode,
            mailid: mailid,
            designation: designation,
            company: company,
            socialmedia: socialmedia,
            aboutspeaker: aboutSpeaker,
            aboutspeakershort: aboutSpeakerShort,
            status: speakerStatus,
            priority : speakerPriority,
            speakerType: speakerType
        }

        // Only include image if it's new upload data (base64), not an existing URL
        if (imageChanged || !editInProgress) {
            evtObj.image = imageupload;
        }

        console.log(evtObj);
        if (editInProgress) {
            try {
                const { data: response, status: statuscode, } = await AxiosAdminInstance.put('/api/admin/createspeaker', evtObj);
                if (response.result == "Success") {
                    toast("Success.");
                    onClickResetEvent(null);
                    setReloadList(!reloadList);
                }
                else {
                    toast.error(response.msg);

                }
            } catch (error: any) {
                console.log(error.status);
            }
            finally {
                setSubmitLoading(false);
            }
        }
        else {
            try {
                const { data: response, status: statuscode, } = await AxiosAdminInstance.post('/api/admin/createspeaker', evtObj);
                if (response.result == "Success") {
                    toast("Success.");
                    onClickResetEvent(null);
                    setReloadList(true);
                }
                else {
                    toast.error(response.msg);

                }
            } catch (error: any) {
                console.log(error.status);
            }
            finally {
                setSubmitLoading(false);
            }
        }

    }

        const convertToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64 = reader.result as string;
                // Remove the data:image/jpeg;base64, prefix
                const base64Data = base64.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = error => reject(error);
        });
    };
    const validateImage = async (event: any) => {

        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0]
            if (file.size > 1 * 300 * 1024) {
                toast.error("File with maximum size of 300KB is allowed");
                return false;
            }
            if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
                toast.error("Only PNG or JPEG Files allowed");
                return false;
            }
            // do other operation
            const base64 = await convertToBase64(file);
            setImageupload(base64);
            setImageChanged(true);
        }
        return true;
    }
    return (
        <>
            <section className="register-sec sec-padding-admin" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-user fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">LIST Speakers</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details">
                        <form>
                            <div className="row pt-2">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="form-field form-label-group-cust pb-2">
                                        <input
                                            id="txtSearchSpeaker"
                                            type="text"
                                            className="form-control-cust"
                                            placeholder="Search by Name, Company, Designation, Mail, Status, Type..."
                                            value={filterText}
                                            onChange={(e) => setFilterText(e.target.value)}
                                        />
                                        <label htmlFor="txtSearchSpeaker">Search Speakers</label>
                                    </div>
                                    <DataTable
                                        columns={listevtcolumns}
                                        data={speakersListresp.filter(
                                            item =>
                                                !filterText ||
                                                (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
                                                (item.company && item.company.toLowerCase().includes(filterText.toLowerCase())) ||
                                                (item.designation && item.designation.toLowerCase().includes(filterText.toLowerCase())) ||
                                                (item.mailid && item.mailid.toLowerCase().includes(filterText.toLowerCase())) ||
                                                (item.status && item.status.toLowerCase().includes(filterText.toLowerCase())) ||
                                                (item.speakerType && item.speakerType.toLowerCase().includes(filterText.toLowerCase()))
                                        )}
                                        progressPending={loading}
                                    />
                                </div>
                            </div>
                        </form>


                    </div> {/* <!--register-sec-details end--> */}
                </div>
            </section>
            <section className="register-sec pb-3" data-scroll-index="8">
                <div className="container">
                    <div className="sec-title">
                        <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-user fa-stack-1x"></i></span></span>
                        <h3 className="wow fadeInRight" data-wow-duration="500ms">Manage Speakers</h3>
                    </div> {/* <!--sec-title end--> */}
                    <div className="register-sec-details ">


                        <form>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <InputComponent custname="speakerName" custid="txtspkrname" custplaceholder="Speaker Name" onExternalValue={setSpeakername} onExternalBind={speakername} />
                                    <InputComponent custname="Company" custid="txtespkrcompany" custplaceholder="Company" onExternalValue={setCompany} onExternalBind={company} />
                                    <InputComponent custname="Designation" custid="txtespkrdesignation" custplaceholder="Designation" onExternalValue={setDesignation} onExternalBind={designation} />
                                    <InputComponent custname="MailId" custid="txtespkrmailid" custplaceholder="Mail Id" onExternalValue={setMailid} onExternalBind={mailid} />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <TextAreaComponent custname="AboutSpeaker" custid="txtspkrabout" custplaceholder="About Speaker" onExternalValue={setAboutSpeaker} onExternalBind={aboutSpeaker} />
                                    <TextAreaComponent custname="AboutSpeakerShort" custid="txtspkraboutshort" custplaceholder="About Speaker Short" onExternalValue={setAboutSpeakerShort} onExternalBind={aboutSpeakerShort} />
                                    <DropDownComponent names={["DRAFT", "OPEN", "CLOSED", "HIDE"]} custname="SpeakerStatus" custid="txtSpkrstatus" custplaceholder="Speaker Status" externalstateValue={speakerStatus} onExternalValue={setSpeakerStatus} />
                                    <FileUploadComponent type="file" custname="imageurl" custid="txtespkrimageurl" custplaceholder="Image" onExternalValue={setImageupload} onExternalBind={imageupload} onChange={(e) => validateImage(e)} />
                                    <DropDownComponent names={["Chief Guests", "Inaugural Speakers", "CXO Speakers", "Technical Speakers", "MidSenior", "Industry Leaders", "Junior", "Trainers"]} custname="SpeakerType" custid="txtSpkrtype" custplaceholder="Speaker Type" externalstateValue={speakerType} onExternalValue={setSpeakerType} />
                                    <InputComponent custname="SpkrPriority" custid="txtespkrpriority" custplaceholder="Speaker Priority" onExternalValue={setSpeakerPriority} onExternalBind={speakerPriority} />
                               
                                </div>
                            </div>
                            <div className="row pt-2">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <InputComponent custname="linkedinLink" custid="txtspkrlinkedin" custplaceholder="LinkedIn Url" onExternalValue={setLinkedInUrl} onExternalBind={linkedInUrl} />
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <InputComponent custname="twitterlink" custid="txtespkrtwitterlink" custplaceholder="Twitter Url" onExternalValue={setTwitterUrl} onExternalBind={twitterUrl} />

                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickAddEvent(e)} >SAVE  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6">
                                    <div className="form-field text-center" >
                                        <button type="submit" disabled={submitLoading} className="btn-default" onClick={(e) => onClickResetEvent(e)} >RESET  {submitLoading ? <i className="fa fa-circle-o-notch fa-spin"></i> : <i className="fa fa-arrow-circle-right"></i>}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <Modal
                            isOpen={modalIsOpen}
                            onAfterOpen={afterOpenModal}
                            onRequestClose={closeModal}
                            style={customStyles}
                            contentLabel="Image Modal"
                        >
                            <div className="row">
                                <div className="col-lg-12 col-md-6 col-sm-6">
                                    <button onClick={closeModal}>X</button>

                                    <img height="250px" src={currImage} />
                                </div>
                            </div>
                        </Modal>
                    </div> {/* <!--register-sec-details end--> */}
                </div>
            </section>
        </>
    );
};




export { AddSpeaker };